import { withNamespaces } from "react-i18next";
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Row,
  Spinner,
  Label,
} from "reactstrap";
import DataFlowRow from "./DataFlowRow";

const DataFlowPanel = ({
  title,
  flows,
  assetOptions,
  dataTypeOptions,
  getSubcategoryOptions,
  requiresTextSubcategory,
  requiresSubcategory,
  onAddClick,
  onSaveRow,
  onDeleteRow,
  isLoading,
  error,
  isSaving,
  isDeleting,
  t,
}) => {
  return (
    // <div className="data-flow__panel border rounded p-3 bg-white">
    <div className="data-flow__panel">
      <div className="data-flow__panel-header">
        <h6 className="mb-0">{title}</h6>
        <Button
          color="primary"
          outline
          className="rounded px-4 py-1 ms-0 p-1"
          onClick={onAddClick}
        >
          <i className="mdi mdi-plus me-3"></i>
          {t("Add Flow")}
        </Button>
      </div>

      {isLoading && (
        <div className="data-flow__empty-state d-flex justify-content-center align-items-center">
          <Spinner size="sm" className="me-2" />
          <span>{t("Loading...")}</span>
        </div>
      )}

      {
        <Card className="data-flow__card-title my-2 rounded-3">
          <CardHeader className="data-flow__card-header py-3">
            <Row>
              <Col xs="12" lg={11}>
                <Row>
                  <Col xs="12" lg="4" className="card-titles">
                    {t("Application")}
                  </Col>
                  <Col xs="12" lg="4" className="card-titles">
                    {t("Type of Data")}
                  </Col>
                  <Col xs="12" lg="4" className="card-titles">
                    {t("Data Category")}
                  </Col>
                  <Col xs="12" lg="3"></Col>
                </Row>
                <Col xs="12" lg={1}></Col>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            {!isLoading && !error && flows?.length > 0 && (
              <div className="data-flow__list">
                {flows.map((row, index) => (
                  <DataFlowRow
                    key={row.id ?? `new-${index}`}
                    row={row}
                    assetOptions={assetOptions}
                    dataTypeOptions={dataTypeOptions}
                    getSubcategoryOptions={getSubcategoryOptions}
                    requiresSubcategory={requiresSubcategory}
                    requiresTextSubcategory={requiresTextSubcategory}
                    onSave={onSaveRow}
                    onDelete={onDeleteRow}
                    isSaving={isSaving}
                    isDeleting={isDeleting}
                    isNew={!!row.isNew}
                  />
                ))}
              </div>
            )}

            {!isLoading && !error && (!flows || flows.length === 0) && (
              <div className="data-flow__empty-state text-muted text-center border rounded p-3">
                {t("No data flows added yet.")}
              </div>
            )}
          </CardBody>
        </Card>
      }
    </div>
  );
};

export default withNamespaces()(DataFlowPanel);
